import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SettingsDialogService {
  private openSettingsSubject = new Subject<void>();
  
  openSettings$ = this.openSettingsSubject.asObservable();
  
  openSettings(): void {
    this.openSettingsSubject.next();
  }
}
